import {
    IAEAColumnDefinition, ICmdSpfrStep1, ICmdSpfrStep2Update, ICmdSpfrStep3Update,
    ICmdSpfrStepSDCUpdate, IDtoSPFrrHeader, IQueryGetSpfr, IQuerySpfr
} from "@models/*";
import { Enums, Constants, Dictionary } from "@utils";
import { String, Utilities } from "../../utils/utilities";
import { SPSubProjectExtentionService } from "./spsubproject.extention.service";

export interface ISPFRRService {
    getHeader(query: IQuerySpfr): Promise<IDtoSPFrrHeader>;
    getDataColumns(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
    getSpfr(query: IQueryGetSpfr): Promise<any>;
    getStepOne(query: IQueryGetSpfr): Promise<any>;
    getStepTwo(query: IQueryGetSpfr): Promise<any>;
    getStepThree(query: IQueryGetSpfr): Promise<any>;
    getSDCStep(query: IQueryGetSpfr): Promise<any>;
    saveSPFRStep1(step1: ICmdSpfrStep1, currentUserEmail: string): Promise<any>;
    saveSPFRStep2(step2: ICmdSpfrStep2Update): Promise<any>;
    saveSPFRStep3(step3: ICmdSpfrStep3Update): Promise<any>;
    saveSPFRStepSDC(stepSDC: ICmdSpfrStepSDCUpdate, userEmail: string): Promise<any>;
}

export class SPFRRService extends SPSubProjectExtentionService implements ISPFRRService {
    //#region Public methods
    public async getHeader(query: IQuerySpfr): Promise<IDtoSPFrrHeader> {
        const budgetHeader: any = await this.getBudgetHeader(query.budgetId);
        let interventionLine = null;
        let objetive = null;
        let financierName = null;
        if (!Utilities.isNullEmptyObject(budgetHeader)) {
            interventionLine = this.getTraductionInterventionLine(query.langLabel, budgetHeader.OCTAVIALineaIntervencion, query.budgetId);
            const details = await this.getBudgetDetails(query.budgetId);

            const Allfinanciers = await this.spListService.getItems({
                listName: Enums.ListTypes.SAPFinancingEntity,
                expands: Constants.Expands.PPRESTIPOFONDO,
                columnsToSelect: Constants.Selects.FINANCERENTITY
            });
            if (details.length > 0) {
                let financiers: Array<string> = [];
                details.forEach((item: any) => {
                    if (!Utilities.isNullEmptyObject(item.OCTAVIAFinanciadorSapId)) {
                        const financierEntity:any = Allfinanciers.find((x:any) => x.Id === item.OCTAVIAFinanciadorSapId);
                        const financierName = this.getTitleTranslate(query.langLabel, item.OCTAVIAFinanciadorSap);
                        if (financiers.indexOf(financierName) === -1 && financierEntity?.PPresTipoFondo?.Title === Enums.FoundType.FFRR){
                            financiers.push(financierName);
                        }
                    }
                });
                financierName = financiers.join(',');
            }

            if (!Utilities.isNullObject(interventionLine)) {
                let strategicLine: any = await this.getInterventionLineObjetive(interventionLine.Id);
                if (strategicLine.length > 0) {
                    let findObjetive: any = await this.getGapById(strategicLine[0].OCTAVIAGapLineaIntervencionId);
                    objetive = this.getTitleTranslate(query.langLabel, findObjetive);
                }
            }
        }
        let responseObject: IDtoSPFrrHeader = {
            projectTitle: budgetHeader.Title,
            projectCode: budgetHeader.PPresCodProy,
            financier: financierName,
            strategicLine: interventionLine?.Title ?? '',
            strategicObjetive: objetive
        };
        return responseObject;
    }
    public async getBudgetDetails(budgetId: number): Promise<any> {

        const parentBudget: any = await this.spListService.getItems<any>({
            listName: Enums.ListTypes.BaseBudget,
            filter: String.Format(Constants.FiltersFormats.FILTER_BY_ID, budgetId),
            columnsToSelect: Constants.Selects.BUDGET_BASIC,
            expands: Constants.Expands.BUDGET_BASIC
        });

        const childsBudget: any = await this.spListService.getItems<any>({
            listName: Enums.ListTypes.BaseBudget,
            filter: String.Format(Constants.FiltersFormats.FILTER_BY_BUDGET, budgetId),
            columnsToSelect: Constants.Selects.BUDGET_BASIC,
            expands: Constants.Expands.BUDGET_BASIC
        });

        let budgetIds = [parentBudget[0].Id];

        budgetIds = [...budgetIds, ...childsBudget.map((x: any) => { return x.Id })];

        let responseApi = await Promise.all(budgetIds.map(async (budgetId: number) => {
            return await this.spListService.getItems<any>({
                listName: Enums.ListTypes.DetailDataBudget,
                filter: String.Format(Constants.FiltersFormats.FILTER_BY_BUDGET, budgetId),
                columnsToSelect: Constants.Selects.BUDGET_DETAILS,
                expands: Constants.Expands.BUDGET_DETAILS
            });
        }));

        let finalArray: any = [];

        responseApi.forEach(x => {
            finalArray = [...finalArray, ...x]
        });
        return finalArray;
    }

    public async getDataColumns(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>> {
        return await this.getDefinitionColumns(langId, Enums.ListTypes.ProaSubproyectoFRDefinicionColumnas);
    }

    public async getStepOne(query: IQueryGetSpfr): Promise<any> {
        return await this.getStep1(query.budgetId);
    }
    
    public async getStepTwo(query: IQueryGetSpfr): Promise<any> {
        return await this.getStep2(query.budgetId);
    }

    public async getStepThree(query: IQueryGetSpfr): Promise<any> {
        return await this.getStep3(query.budgetId);
    }

    public async getSDCStep(query: IQueryGetSpfr): Promise<any> {
        return await this.getStepSDC(query);
    }

    public async getSpfr(query: IQueryGetSpfr): Promise<any | null> {

        let [step1Response, step2Response, step3Response, step4Response, stepSDC, step4Mri] = await Promise.all([
            this.getStep1(query.budgetId), 
            this.getStep2(query.budgetId),
            this.getStep3(query.budgetId),
            this.getFEStep4({
                budgetId: query.budgetId,
                subventionCodeId: null,
                grantCode: null,
            }),
            this.getStepSDC(query),
            this.getFEStep4Mri({
                budgetId: query.budgetId,
                subventionCodeId: null,
                grantCode: null,
            })
        ]);

        return {
            step1: step1Response,
            step2: step2Response,
            step3: step3Response,
            step4: step4Response,
            stepSDC,
            step4Mri
        };
    }

    public async saveSPFRStep1(step1: ICmdSpfrStep1, currentUserEmail: string): Promise<any> {
        delete step1.genericInfo.PProaUnidadMedida;
        let currentUsu = await this.spWebService.ensureUser(currentUserEmail);

        if (step1.genericInfo.Id === 0) {
            return await this.saveStep1(step1, currentUsu.Id);
        }else {
            return await this.updateStep1(step1, currentUsu.Id);
        }
    }

    public async saveSPFRStep2(step2: ICmdSpfrStep2Update): Promise<any> {
        return await this.updateStep2(step2, step2.budgetId);
    }

    public async saveSPFRStep3(step3: ICmdSpfrStep3Update): Promise<any> {
        return await this.updateStep3(step3, step3.budgetId);
    }

    public async saveSPFRStepSDC(stepSDC: ICmdSpfrStepSDCUpdate, currentUserEmail: string): Promise<any> {
        let currentUsu = await this.spWebService.ensureUser(currentUserEmail);
        return await this.updateStepSDC(stepSDC, stepSDC.budgetId, currentUsu.Id);
    }

    //#endregion
}